import {
  Mail,
  Shield,
  Calendar,
} from 'lucide-react'
import { useUserContext } from './UserDetailLayout'
import { formatDate } from '../../../utils/dateUtils'

export function UserOverviewTab() {
  const {
    userData,
    isEditing,
    formData,
    setFormData,
  } = useUserContext()

  if (!userData) return null


  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Personal Info */}
      <div className="card">
        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          Información del Usuario
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Nombre
            </label>
            {isEditing ? (
              <input
                type="text"
                className="input"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            ) : (
              <p className="text-gray-900 dark:text-white">{userData.name}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Email
            </label>
            {isEditing ? (
              <input
                type="email"
                className="input"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            ) : (
              <p className="flex items-center gap-2 text-gray-900 dark:text-white">
                <Mail className="h-4 w-4 text-gray-400" />
                {userData.email}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Account Info */}
      <div className="card">
        <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">
          Información de la Cuenta
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Rol
            </label>
            <p className="flex items-center gap-2 text-gray-900 dark:text-white">
              <Shield className="h-4 w-4 text-gray-400" />
              Administrador
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Fecha de Creación
            </label>
            <p className="flex items-center gap-2 text-gray-900 dark:text-white">
              <Calendar className="h-4 w-4 text-gray-400" />
              {formatDate(userData.createdAt)}
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Estado
            </label>
            <span className={`badge ${userData.isActive ? 'badge-success' : 'badge-gray'}`}>
              {userData.isActive ? 'Activo' : 'Inactivo'}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
